import type { Context } from "./types";

export function createInitialContext(): Context {
  return {
    uid: "",
    winnerId: null,
    token: null,
    sessionId: null,
    signature: null,
    theme: 0,
    isMale: null,
    isRegistered: false,
    characterMode: null,
    assets: {},
    capture: {},
    score: 0,
  };
}
